export enum ReferralControlsEnum {
    REFERRAL_LINK = 'referral_link',
}
